import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { PumpdashboardComponent } from "../pumpdashboard/pumpdashboard.component";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DashboardService } from '../services/dashboard.service';
import { PumpService } from '../services/pump.service';
import {
  MatPaginator,
  MatSort,
  MatTableDataSource,
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material";
import { element } from "protractor";
export interface TransformerData {
  // No: any;
   TransformerID: any;
   SiteName: any;
   //LoadDetails: any;
   PumpID: any;
   Communication: any;
  // Voltage: any;
  // Current: any;
   Status: any;
 }
 
@Component({
  selector: 'app-pumppopuptable',
  templateUrl: './pumppopuptable.component.html',
  styleUrls: ['./pumppopuptable.component.scss']
})
export class PumppopuptableComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ELEMENT_DATA: TransformerData[] = [];
  displayedColumns: string[] = [
   // "No",
    "TransformerID",
    "SiteName",
    //"LoadDetails",
    "PumpID",
    "Communication",
   // "Voltage",
   // "Current",
    //"Status",
  ];
  dataSource;
  alertsData;
  loadPercentage;
  constructor(private _dashboardService: DashboardService,
    private router: Router,private dialogRef: MatDialogRef<PumpdashboardComponent>,
    @Inject(MAT_DIALOG_DATA) public data,private pumpservice: PumpService
  ) { }
  ngOnInit() {

    console.log("fuck off evryone",this.data)
    this.getData();
  }

  close() {
    this.dialogRef.close();
  }
  getData(){
    if(this.data.type == "total"){
      let tileData = [];
      this.data.TransformerData.forEach(element =>{
        tileData.push({
          TransformerID: element.transformerid,
          SiteName: element.sitename,
          PumpID: element.pump_id,
          Communication: 1,
        })
      })
      this.dataSource = tileData;
    } else {
      let tileData = [];
      const pumpIdsArray = this.data.TransformerData.map(pump => pump.pump_id);
      this.pumpservice.getPumpDataTile({type:this.data.type,pumpArray:pumpIdsArray}).subscribe((response1: any) => {
        if(response1.result.length > 0){
          let data = response1.result;
        data.forEach(element =>{
          tileData.push({
            TransformerID: element.transformerid,
            SiteName: element.sitename,
            PumpID: element.pump_id,
            Communication: 1,
          })
        });
        this.dataSource = tileData;
        }
      });
    }
  }
}
